"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = require("react");
var _needCss = _interopRequireDefault(require("need-css"));
//@ts-check

/**
 * @param {string[]} mods
 * @param {string} groupKey
 */
var useCSS = function useCSS(mods, groupKey) {
  /**
   * @type {React.MutableRefObject<boolean | undefined>}
   */
  var injects = (0, _react.useRef)();
  if (!injects.current) {
    injects.current = true;
    (0, _needCss["default"])(mods, groupKey);
  }
};
var _default = exports["default"] = useCSS;
module.exports = exports.default;